import { getFileExtension } from "sprint-common-web";

export const hasFileExtension = (path: string): boolean => {
    return !!getFileExtension(path);
};
